import { Sun, Sunset, Moon, CheckCircle2 } from "lucide-react";
import { useState } from "react";

const SESSIONS = [
  {
    id: "1", title: "Session 1 — Réveil (45 min)", time: "08:00 — 08:45", icon: Sun, color: "#CCFF00",
    desc: "Démarrer le compte avec des signaux positifs avant tout post.",
    tasks: [
      "Scroll feed 10 min (signal naturel)",
      "Liker 20 stories de l'audience cible",
      "Répondre aux DMs en attente (max 30 min)",
      "Liker + commenter 15 posts dans la niche",
      "Analyser les KPIs des posts H-24",
    ]
  },
  {
    id: "2", title: "Session 2 — Push (60 min)", time: "12:30 — 13:30", icon: Sunset, color: "#00D4FF",
    desc: "Phase d'engagement actif & poste du jour.",
    tasks: [
      "Publier le contenu du jour (Reel/Post)",
      "Story du Reel 1h après publication",
      "Commenter sous 5 gros comptes (réponse first 30min)",
      "Cross-post Threads / X dans les 5 minutes",
      "DM cold value-first (10-20 max)",
    ]
  },
  {
    id: "3", title: "Session 3 — Lock (30 min)", time: "20:00 — 20:30", icon: Moon, color: "#A1A1AA",
    desc: "Verrouillage des signaux, analyse, préparation du lendemain.",
    tasks: [
      "Répondre à TOUS les commentaires du post du jour",
      "Spy 3 concurrents (hooks + structures)",
      "Préparer le brief du contenu de demain",
      "Vérifier KPIs : reach, watchtime, save rate",
      "Story finale : sondage ou question (engagement)",
    ]
  },
];

export default function Routine() {
  const [done, setDone] = useState({});
  const toggle = (k) => setDone(d => ({ ...d, [k]: !d[k] }));

  return (
    <div className="space-y-8 animate-fadeUp" data-testid="routine-page">
      <header className="border-l-2 border-[#CCFF00] pl-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// ROUTINE QUOTIDIENNE</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">3 sessions. 1 machine.</h1>
        <p className="text-zinc-400 mt-2">2h15 par jour bien réparties. Pas de bordel, pas d'oubli, output prédictible.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {SESSIONS.map(s => {
          const Icon = s.icon;
          const total = s.tasks.length;
          const completed = s.tasks.filter((_, i) => done[`${s.id}-${i}`]).length;
          return (
            <div key={s.id} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6 space-y-4" data-testid={`session-${s.id}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-sm flex items-center justify-center" style={{ background: `${s.color}15`, border: `1px solid ${s.color}40` }}>
                    <Icon className="w-5 h-5" style={{ color: s.color }} strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-display text-lg font-semibold text-white">{s.title}</div>
                    <div className="font-mono text-[11px] text-zinc-500 uppercase tracking-wider">{s.time}</div>
                  </div>
                </div>
                <span className="font-mono text-xs" style={{ color: s.color }}>{completed}/{total}</span>
              </div>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              <ul className="space-y-2">
                {s.tasks.map((t, i) => {
                  const k = `${s.id}-${i}`;
                  const isDone = done[k];
                  return (
                    <li key={i}>
                      <button onClick={() => toggle(k)} data-testid={`task-${s.id}-${i}`}
                        className={`w-full text-left flex items-start gap-2.5 p-2 rounded-sm transition ${isDone ? "opacity-50" : "hover:bg-white/[0.03]"}`}>
                        <CheckCircle2 className={`w-4 h-4 shrink-0 mt-0.5 transition-colors`}
                          style={{ color: isDone ? s.color : "#52525B" }}
                          fill={isDone ? s.color : "none"} strokeWidth={1.5} />
                        <span className={`text-sm ${isDone ? "line-through text-zinc-500" : "text-white"}`}>{t}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="border border-[#CCFF00]/30 bg-[#CCFF00]/[0.03] rounded-sm p-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[#CCFF00] mb-2">// RÈGLE D'OR</div>
        <p className="text-zinc-200">
          Mieux vaut <span className="text-[#CCFF00] font-medium">2h structurées</span> que 6h éparpillées. La routine bat la motivation. <span className="font-mono text-zinc-400">Le compte qui scale est celui qui ne rate jamais 7 jours d'affilée.</span>
        </p>
      </div>
    </div>
  );
}
